import React, { useState, useRef, useCallback, memo, useEffect } from 'react';
import InModalSpq from './InModalSpq';
import { useDispatch, useSelector } from 'react-redux';
let timeoutHandler = null;

const VIDEO_TYPE_MAIN = 'content';
let handlerCheckCounter = 0;
const InteractiveSpq = ({ height, onQuizStart, onQuizEnd }) => {
  // console.log('@@ rendering', currentQueueData);
  const [modalShow, setModalShow] = useState(false);
  const [isSkipable, setIsSkipable] = useState(false);
  // const [spqData, setSpqData] = useState('');
  let spqData = useSelector((state) => state.videoPlayer.spqItem);

  const count = useRef(0);

  const spqIndex = useRef(0);
  useEffect(() => {
    setIsSkipable(false);
    setModalShow(false);
    return () => {
      setIsSkipable(false);
      setModalShow(false);
    };
  }, []);
  useEffect(() => {
    if (spqData && spqData?.survey_id) {
      if (spqData?.skip && spqData?.skip != 0) {
        setIsSkipable(true);
      }
      handleOpen();
    }
    return () => {};
  }, [spqData]);

  // console.log('quiz start',onQuizStart)

  // const spqHandler = (currentTime, spq_data, duration, spqData) => {
  //   handlerCheckCounter += 1;
  //   if (handlerCheckCounter <= 5) {
  //     return false;
  //   }
  //   handlerCheckCounter = 0;
  //   if (spqData || spq_data?.length <= 0) {
  //     return false;
  //   }
  //   console.log('spq handler.........|||');
  //   let percentageViewed = '';
  //   percentageViewed = (currentTime * 100) / duration;
  //   let spqQueueItem = '';
  //   spqQueueItem = spq_data?.length > 0 ? spq_data[spqIndex.current] : {};
  //   console.group('spq Handler');
  //   console.log(
  //     'spq data',

  //     duration,
  //     currentTime,
  //     percentageViewed,
  //     '\n',
  //     spq_data,
  //     '\n',
  //     spqIndex.current,
  //     '\n',
  //     spqQueueItem,
  //     spqData
  //   );
  //   console.groupEnd('spq Handler');

  //   if (
  //     percentageViewed >= 0 &&
  //     spqQueueItem?.duration >= 0 &&
  //     Math.ceil(percentageViewed) >= Math.ceil(spqQueueItem?.duration)
  //   ) {
  //     // console.log('Spq handler in ', spqQueueItem, percentageViewed);

  //     if (!spqData && spqQueueItem) {
  //       console.log('interactiveSPQ open###', spqQueueItem, modalShow);
  //       setTimeout(() => {
  //         handleOpen();
  //       }, 2000);
  //     }
  //     if (spqQueueItem?.skip) {
  //       setIsSkipable(true);
  //     }
  //     setSpqData(spqQueueItem);
  //   } else {
  //     // console.log('spq item else', spqQueueItem);
  //   }
  //   // console.groupEnd('skip btn logic');
  // };

  // useEffect(() => {
  //   // console.log('spq handler-----------', '\n', isLoading, videoType, spqData);
  //   if (videoType != VIDEO_TYPE_MAIN || spqData) {
  //     // console.log('spq1-----------||||||||||||||||||||||||');
  //     return false;
  //   } else if (currentTime <= 0 || duration <= 0 || allSpqData?.length <= 0 || spqData) {
  //     // console.log('spq2-----------||||||||||||||||||||||||');
  //     return false;
  //   } else if (videoType == VIDEO_TYPE_MAIN && !spqData) {
  //     // console.log('spq3-----------||||||||||||||||||||||||', spqData);
  //     spqHandler(currentTime, allSpqData, duration, spqData);
  //   } else {
  //     console.log('spq handler not needed');
  //   }
  // }, [duration, currentTime, allSpqData, videoType, spqData]);

  const handleOpen = () => {
    setModalShow(true);
    onQuizStart();
  };

  const handleClose = useCallback(() => {
    console.log('interactiveSPQclose ###', `count${count.current}`, spqIndex.current);
    setIsSkipable(false);
    setModalShow(false);
    onQuizEnd();
  }, [modalShow, spqData]);

  const onSkipspq = () => {
    console.log('||||||||||||||||||');
    // setSpqData('');
    onQuizEnd();
    setIsSkipable(false);
    setModalShow(false);
  };

  // console.log('@@', modalShow, spqData);
  return (
    <>
      {modalShow && spqData && spqData?.survey_id ? (
        <section className="cmnPageContent videoSpqArea" style={{ height: `${height}px` }}>
          {/* {console.log('spqData', spqData)} */}
          <InModalSpq
            id={spqData?.survey_id}
            skipBtn={isSkipable}
            handleClose={handleClose}
            data={spqData}
          />

          {/* {isSkipable && ( */}
          <button className="clr_player_spq_skipBtn" type="button" onClick={onSkipspq}>
            Skip
          </button>
          {/* )} */}
        </section>
      ) : null}
    </>
  );
};

export default memo(InteractiveSpq);
